export default __webpack_public_path__ + "static/A-LIGN-SOC-BadgeTwo-b94002765d818f4665d1b97b89c8567a.png";